import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getInvitationsByUserId, 
  updateInvitation, 
  updateGroupInvitation, 
  getInvitationCodesByUserId, 
  postNamedGogInvite 
} from "./Api";

// ? Initial State
export const initialState = {
  invitationType: "",
  selectedInvitationType: {},
  loading: false,
  error: null,
};

const invitationSlice = createSlice({
  name: "invitation",
  initialState,
  reducers: {
    selectInvitation: (state, action) => {
      state.invitationType = action.payload;
      console.log("heloo wordl", state.invitationType);
    },
    selectedInvitationTypeForGroup: (state, action) => {
      state.selectedInvitationType = action.payload;
      console.log("invitation", action.payload);
    },
  },
});

export const toggleNamedGogInvite = createAsyncThunk(
  "invitationSlice/toggleNamedGogInvite",
  async (data) => {
    const response = await postNamedGogInvite(data);
    return response.data;
  }
);

export const invitationsByUserId = createAsyncThunk(
  "invitationSlice/getInvitationsByUserId",
  async () => {
    const response = await getInvitationsByUserId();
    return response.data;
  }
);

export const invitationCodesByUserId = createAsyncThunk(
  "invitationSlice/getinvitationCodesByUserId",
  async () => {
    const response = await getInvitationCodesByUserId();
    return response.data;
  }
);

export const updateInvite = createAsyncThunk(
  "invitationSlice/updateInvite",
  async (data) => {
    const response = await updateInvitation(data);
    return response.data;
  }
);
export const updateGroupInvite = createAsyncThunk(
  "invitationSlice/updateGroupInvite",
  async (data) => {
    const response = await updateGroupInvitation(data);
    return response.data;
  }
);

// Export the actions and reducer
export const { selectInvitation, selectedInvitationTypeForGroup } =
  invitationSlice.actions;
export default invitationSlice.reducer;
